import styles from './Badge.module.scss';

export type BadgeProps = {
  children?: React.ReactNode;
  color?: string;
  size?: 'default' | 'large';
};

function Badge({ children, color = 'primary', size = 'default' }: BadgeProps) {
  return (
    <div
      className={`${styles.componentStyle} ${styles[size]}`}
      style={{
        background: `var(--color-${color})`,
      }}
    >
      {children}
    </div>
  );
}

export default Badge;
